"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDialog = function () {
    var _a = react_1.useState(false), isDialogOpen = _a[0], setIsDialogOpen = _a[1];
    function closeDialog() {
        setIsDialogOpen(false);
    }
    function openDialog() {
        setIsDialogOpen(true);
    }
    return {
        isDialogOpen: isDialogOpen,
        openDialog: openDialog,
        closeDialog: closeDialog,
    };
};
exports.default = useDialog;
//# sourceMappingURL=useDialog.js.map